// Internalized from @videoplatform/data-types (api module). The lazy/LazyLoader
// export was unused and dropped.
import * as _ from 'lodash';

export type LoadingPlaceholder = 'LOADING';
export type ForeignResource<T> = T | Error | LoadingPlaceholder;

export function isLoaded<T>(resource: ForeignResource<T>): resource is T {
    return !_.isError(resource) && resource !== 'LOADING';
}

export function isLoading<T>(resource: ForeignResource<T>): resource is 'LOADING' {
    return resource === 'LOADING';
}

export type IFetcher = typeof window.fetch;

export interface IApplicationOptions {
    apiBaseUrl: string;
    applicationRoot: string;
    wrappedFetch: IFetcher;
}

export interface IWithApiOptionsProps {
    apiOptions: IApplicationOptions;
}
